import React, { type FunctionComponent } from 'react'
import { FormattedMessage } from 'react-intl'
import moment from 'moment'
import { DashButton } from 'legacy/dash-blocks/dash-button/DashButton'
import { DashContentBar } from 'legacy/dash-blocks/dash-content-bar/DashContentBar'
import { DateSelectRange } from 'legacy/dash-components/date-select-range/DateSelectRange'
import { RetailerLocationSelect } from 'legacy/dash-components/retailer-location-select/RetailerLocationSelect'
import { OrderSourceFilter } from 'legacy/dash-components/order-source-filter/OrderSourceFilter'
import { type OrdersListBehaviour } from 'legacy/sections/orders/components/list/utils/ordersList.hooks'
import { OrderListFiltersByNumber } from 'legacy/sections/orders/components/list/components/filters/components/OrderListFiltersByNumber'

const buttonStyleOverrides = {
  textTransform: 'uppercase',
} as const

interface Props extends OrdersListBehaviour {}

const MAX_RANGE_DATE = moment().startOf('day').add(8, 'days')

export const OrdersListFilters: FunctionComponent<Props> = ({
  queryParamsBehaviour: {
    dateSelectRangeValue,
    setDateSelectRangeValue,
    orderSource,
    setOrderSource,
    pendingOrderNumber,
    setPendingOrderNumber,
    clearSearch,
    executeSearch,
    clearSearchDisabled,
    executeSearchDisabled,
    retailerLocationSelectValue,
    setRetailerLocationSelectValue,
  },
}) => (
  <DashContentBar
    overrideStyle={{
      marginLeft: 2,
    }}
    leftComponents={[
      <DateSelectRange
        key="date-select-range"
        value={dateSelectRangeValue}
        onChange={setDateSelectRangeValue}
        maxDate={MAX_RANGE_DATE}
      />,
      <RetailerLocationSelect
        key="retailer-location-select"
        value={retailerLocationSelectValue}
        onChange={setRetailerLocationSelectValue}
      />,
      <OrderSourceFilter key="order-source-filter" value={orderSource} onChange={setOrderSource} />,
    ]}
    rightComponents={[
      <OrderListFiltersByNumber
        key="order-list-filters-by-number"
        value={pendingOrderNumber}
        onChange={setPendingOrderNumber}
      />,

      <DashButton
        key="search-button"
        buttonStyle={buttonStyleOverrides}
        onClick={executeSearch}
        disabled={executeSearchDisabled}
      >
        <FormattedMessage id="label.search" />
      </DashButton>,

      <DashButton
        key="clear-button"
        variant="flat"
        disabled={clearSearchDisabled}
        buttonStyle={buttonStyleOverrides}
        onClick={clearSearch}
      >
        <FormattedMessage id="button.clear" />
      </DashButton>,
    ]}
  />
)
